import React, { useEffect, useState, useRef } from "react";
import {
  Autocomplete,
  Box,
  FormControl,
  MenuItem,
  TextField,
} from "@mui/material";
// import StyledTextField from "../../styled-components/StyledTextField";
import styles from "../EntityEditor.styles";
import { connect, useDispatch } from "react-redux";
import { receiveCompanyRequest } from "../../../../modules/search/actions/search";
import { selectSearch } from "../../../../modules/search/selectors";
import { scrollLock } from './GeneralFieldsBlock';
import type { RootState } from '../../../../reducers';
import { StyledInputLabel, StyledSelect } from '../../styled-components/StyledSelect';
import { SelectChangeEvent } from '@mui/material/Select';

const searchOptions = [
  {
    label: "Kadaster personal number",
    value: "kadaster_personal_number",
  },
  {
    label: "Chamber commerce number",
    value: "chamber_commerce_number",
  },
  {
    label: "Company name",
    value: "company_name",
  },
];

const initialCompanyState = {
  fieldType: searchOptions[2].value || "",
  companyName: "",
  companyId: "",
  query: "",
  limit: 7,
};

const EntityCompanyBlock = ({ companyResult, onChange, entityCompany }) => {
  const dispatch = useDispatch();
  const [isFocused, setIsFocused] = useState(false);
  const [companyState, setCompanyState] = useState(initialCompanyState);
  const { fieldType, query, limit } = companyState;
  const [value, setValue] = useState(null);
  const [inputValue, setInputValue] = React.useState("");
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<any[]>([]);
   const autocompleteRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (Object.keys(entityCompany).length) {
      setValue(entityCompany);
    } else {
      setValue(null);
      setInputValue("");
    }
  }, [entityCompany]);

  useEffect(() => {
    let active = true;
    let newOptions: any = [];

    if (inputValue === "") {
      setOptions(value ? [value] : []);
      // setCompanyState(initialCompanyState);
      onChange("entity_company_id", []);
      return undefined;
    }
    if (active) {
      if (value) {
        newOptions = [value];
      }
      if (companyResult?.length) {
        newOptions = [...newOptions, ...companyResult];
        onChange("entity_company_id", companyResult);
      }
      setOptions(newOptions);
    }

    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, value, inputValue, companyResult]);

  useEffect(() => {
    if (inputValue.length <= 1) {
      setOptions([]);
      setOpen(false);
    }
  }, [inputValue]);

  useEffect(() => {
    if (options?.length && isFocused) {
      scrollLock(isFocused);
    } else {
      scrollLock(isFocused);
    }
  }, [options, isFocused]);

  useEffect(() => {
    if (value) {
      setCompanyState({
        ...companyState,
        // @ts-ignore
        companyName: value.company_name,
        // @ts-ignore
        companyId: value.id,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  useEffect(() => {
    if (open && !isFocused && options?.length) {
      const timeout = setTimeout(() => {
        autocompleteRef.current?.focus();
        setIsFocused(true);

      }, 100);
      return () => {
        clearTimeout(timeout);
      }
    }
  }, [isFocused, open, options]);

  const handleFocus = () => {
    setIsFocused(true);
  }

  const handleBlur = (event: React.FocusEvent<HTMLElement>): void => {
    const relatedTarget = event.relatedTarget as HTMLElement | null;
    if (relatedTarget && autocompleteRef.current &&  autocompleteRef.current.contains(relatedTarget)) {
      return
    }
    setIsFocused(false);
  };

  const handleChange = (
    key: string,
    event: SelectChangeEvent
  ) => {
    if (key === "fieldType") {
      setCompanyState({
        ...companyState,
        [key]: event.target.value,
      });
    }
  };

  const handleChangeInput = (newInputValue: string) => {
    setInputValue(newInputValue);

    setCompanyState({
      ...companyState,
      query: newInputValue,
    });
  };

  useEffect(() => {
    if (query.length >= 2) {
      dispatch(receiveCompanyRequest({ query, fieldType, limit }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  return (
    <Box sx={styles.fieldHolder}>
      <Box sx={styles.fieldBlock}>
        <FormControl
          fullWidth
          margin="dense"
        >
          <StyledInputLabel
            id="select-field-type-label"
            htmlFor="select-field-type-input"
          >
            Search type
          </StyledInputLabel>
          <StyledSelect
            labelId="select-field-type-label"
            id="select-field-type"
            name="fieldType"
            value={companyState.fieldType}
            label="Search type"
            onChange={(event: SelectChangeEvent) => handleChange("fieldType", event)
            }
            inputProps={{
              id: 'select-field-type-input',
            }}
          >
            {searchOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </StyledSelect>
        </FormControl>
        {/*<StyledTextField*/}
        {/*  fullWidth*/}
        {/*  select*/}
        {/*  label="Search type"*/}
        {/*  name="fieldType"*/}
        {/*  margin="dense"*/}
        {/*  onChange={(event: React.ChangeEvent<HTMLInputElement>) =>*/}
        {/*    handleChange("fieldType", event)*/}
        {/*  }*/}
        {/*  value={companyState.fieldType}*/}
        {/*>*/}
        {/*  {searchOptions.map((option) => (*/}
        {/*    <MenuItem key={option.value} value={option.value}>*/}
        {/*      {option.label}*/}
        {/*    </MenuItem>*/}
        {/*  ))}*/}
        {/*</StyledTextField>*/}
      </Box>
      <Box sx={styles.fieldBlock}>
        <FormControl sx={{ mt: 1, mb: 0.5 }}>
          <Autocomplete
            id="company"
            // disabled={!area_filters.city}
            // sx={{ marginBottom: "5px" }}
            open={open && inputValue.length >= 2}
            onOpen={() => {
              setOpen(true);
            }}
            onClose={() => {
              setOpen(false);
            }}
            options={options}
            openOnFocus={isFocused}

            freeSolo
            // loading={true}
            filterOptions={(x) => x}
            autoComplete
            includeInputInList
            filterSelectedOptions
            value={value}
            // blurOnSelect
            fullWidth
            getOptionLabel={(option) => {
               return option.company_name ? option.company_name : "n/a"
            }}
            isOptionEqualToValue={(option, val) => option.id === val.id}
            renderOption={(props, option, index) => (
              <li {...props} key={option.id ?? index}>
                {option.company_name ? option.company_name : "n/a"}
              </li>
            )

            }
            onChange={(_e, newValue) => {
              setOptions(newValue ? [newValue, ...options] : options);
              setValue(newValue);
            }}
            inputValue={inputValue}
            onInputChange={(_e, newInputValue) =>
              handleChangeInput(newInputValue)
            }
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Сompany"
                onFocus={handleFocus}
                onBlur={handleBlur}
                inputRef={autocompleteRef}
              />
            )}
          />
        </FormControl>
      </Box>
    </Box>
  );
};

function mapStateToProps(state: RootState) {
  const { companyResult } = selectSearch(state);
  return { companyResult };
}

export default connect(mapStateToProps)(EntityCompanyBlock);
